const numberFormatter = new Intl.NumberFormat("zh-CN");

export function countReadableCharacters(text: string): number {
  return (text.match(/[\p{L}\p{N}]/gu) ?? []).length;
}

export function formatWordCount(count: number): string {
  return `约 ${numberFormatter.format(count)} 字`;
}
